export default __webpack_public_path__ + "static/media/cp_geo_ks.d782f642.svg";